module.exports = __webpack_public_path__ + "static/img/bonus_9.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_9.png
// module id = 9B7E
// module chunks = 0